import { jsx as i } from "react/jsx-runtime";
import { c as p } from "react/compiler-runtime";
import { TableCell as s } from "@mui/material";
import { forwardRef as f } from "react";
const C = f((t, m) => {
  const e = p(7);
  let l, o;
  e[0] !== t ? ({
    children: l,
    ...o
  } = t, e[0] = t, e[1] = l, e[2] = o) : (l = e[1], o = e[2]);
  let r;
  return e[3] !== l || e[4] !== o || e[5] !== m ? (r = /* @__PURE__ */ i(s, { ref: m, ...o, children: l }), e[3] = l, e[4] = o, e[5] = m, e[6] = r) : r = e[6], r;
});
export {
  C as TableCell
};
